import { render, staticRenderFns } from "./RewardTableViewForm.vue?vue&type=template&id=64287504&"
import script from "./RewardTableViewForm.vue?vue&type=script&lang=js&"
export * from "./RewardTableViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports